"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnlexerError = void 0;
const token_1 = require("./token");
const strings_1 = require("./strings");
class UnlexerError extends Error {
    constructor(message) {
        super(message);
        this.message = message;
        this.name = 'UnlexerError';
        this.stack = new Error().stack;
    }
}
exports.UnlexerError = UnlexerError;
function unlex(tokens) {
    let str = '';
    for (let i = 0; i < tokens.length; i++) {
        const token = tokens[i];
        // Break if we hit an EOS
        if (token.type === token_1.TokenType.EOS) {
            break;
        }
        if (token.type === token_1.TokenType.Err) {
            return {
                code: str,
                error: new UnlexerError(`Unlexing hit an error with message: "${token.value}"`)
            };
        }
        // Don't add unecessary spaces to dots
        if (token.type === token_1.TokenType.Dot) {
            str += token.value;
            continue;
        }
        // Add a space, but not after dots
        if (i > 0 && tokens[i - 1].type !== token_1.TokenType.Dot) {
            str += ' ';
        }
        if (token.type === token_1.TokenType.Ident) {
            str += escape(token.value);
        }
        else {
            str += token.value;
        }
    }
    return { code: str.trim() };
}
exports.default = unlex;
function escape(str) {
    let escaped = '';
    for (const c of str) {
        if (!strings_1.isIdent(c) || c === '\\') {
            escaped += '\\';
        }
        escaped += c;
    }
    return escaped;
}
//# sourceMappingURL=unlexer.js.map